import {
    BaseRequestPolicy,
    HttpOperationResponse,
    RequestPolicy,
    RequestPolicyFactory,
    RequestPolicyOptions,
    WebResource,
} from '@azure/ms-rest-js';

import { TokenProvider } from '../helpers/TokenProvider';

class AuthorizationPolicy extends BaseRequestPolicy {
    private readonly headerName: string = 'Authorization';

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor -- It's not useless, as it gives *public* access to the constructor
    constructor(nextPolicy: RequestPolicy, options: RequestPolicyOptions) {
        super(nextPolicy, options);
    }

    async sendRequest(request: WebResource): Promise<HttpOperationResponse> {
        await this.addAuthorizationHeader(request);

        return this._nextPolicy.sendRequest(request);
    }

    private async addAuthorizationHeader(request: WebResource): Promise<void> {
        const token = await TokenProvider.getAuthorizationToken();

        if (!request.headers.get(this.headerName) && token) {
            request.headers.set(this.headerName, token);
        }
    }
}

export const authorizationPolicy = (): RequestPolicyFactory => ({
    create: (nextPolicy: RequestPolicy, options: RequestPolicyOptions): RequestPolicy =>
        new AuthorizationPolicy(nextPolicy, options),
});
